import styled from "styled-components";
import { Wrapper } from "../../common";

export const WrapperBox = styled(Wrapper)`
    display: block;
    width: 100%;
    height: calc(100vh - 80px);
    background-color: white;
    padding: 0;
    overflow: hidden;
`;

export const WrapperWithout = styled(Wrapper)`
    display: block;
    width: 100%;
    background-color: white;
    padding: 0;
    overflow: hidden;
`;

export const LoyaltyInfo = styled.div`
    display: flex;
    align-items: center;
    padding: 0px 28px;
    & > svg {
        fill: ${props => props.theme.colors.primary};
        font-size: 40px;
    }
    span {
        font-size: 16px;
        margin-left: 16px;
        font-weight: 300;
        b {
            font-weight: bold;
        }
    }
`

export const LoyaltyFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
    padding: 0 28px 28px;
`

